// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2UP8W","checkboxCol":"Table_checkboxCol__al-sV","emailCol":"Table_emailCol__1R07c","actionCol":"Table_actionCol__Jf5pS"};